/** Resolve every retained document before sending any mutation. Failure never becomes an empty upload. */
export const resolveRetainedDocuments = async (files, saved, download) => {
    const selected = files?.length ? files : saved.map(d => new File([], d.name));
    return Promise.all(selected.map(async (file) => {
        if (file.size > 0)
            return file;
        const matches = saved.filter(d => d.name === file.name);
        if (matches.length !== 1)
            throw new Error('The existing document cannot be identified. Reload before saving.');
        const document = matches[0];
        const blob = await download(document);
        if (blob.size < 5 || await blob.slice(0, 5).text() !== '%PDF-')
            throw new Error('The existing PDF could not be downloaded. No changes were saved.');
        return new File([blob], document.name, { type: 'application/pdf' });
    }));
};
